import { render, staticRenderFns } from "./PaytableSymbol.vue?vue&type=template&id=2599b3d0&"
import script from "./PaytableSymbol.vue?vue&type=script&lang=ts&"
export * from "./PaytableSymbol.vue?vue&type=script&lang=ts&"
import style0 from "./PaytableSymbol.vue?vue&type=style&index=0&id=2599b3d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports